module.exports = __webpack_public_path__ + "img/14.27c9d443.jpg";